import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-solid-svg-icons";
import {faArrowLeft, faArrowRight} from "@fortawesome/pro-regular-svg-icons";
import {Popover, Position} from 'devextreme-react/popover';

import './walkthrough-style.css'

import WalkthroughItem from "./walkthrough-item.ts";
import Button from "@/components/buttons/button";

interface WalkthroughProps {
    isWalkthroughOpen?: boolean;
    items: WalkthroughItem[];
    
    refreshKey?: string | number;
    showShade?: boolean;
}

const Walkthrough: React.FC<WalkthroughProps> = ({items, isWalkthroughOpen, refreshKey, showShade = true}) => {

    const [currentItemIndex, setCurrentItemIndex] = useState(0);
    const [isInternalWalkthroughOpen, setIsInternalWalkthroughOpen] = useState(isWalkthroughOpen ?? true);
    const currentItem = items[currentItemIndex];

    if (!isInternalWalkthroughOpen || !currentItem) {
        return null;
    }

    return (
        <>
            {showShade && <div className='pointer-events-auto fixed inset-0 bg-neutral-200/25 z-10' />}
            
            <Popover target={`#${currentItem?.targetId}`} hideOnOutsideClick={false} visible={isInternalWalkthroughOpen} position={currentItem.position ?? 'bottom'}
                     minWidth={250}  wrapperAttr={{class: `walkthrough-popover walkthrough-popover-${(currentItem.position instanceof Position ? currentItem.position : 'bottom') ?? 'bottom'}`}}
                     key={`${currentItem.targetId}-${refreshKey ?? 0}`}>
                <div className='flex flex-col gap-y-2'>
                    <div className='flex flex-row justify-between items-center gap-x-2'>
                        {currentItem.title && <span className='font-bold'>{currentItem.title}</span>}

                        <Button variant='ghost' size='xs' className='ml-auto' onClick={() => setIsInternalWalkthroughOpen(false)}>
                            <FontAwesomeIcon icon={faXmark} className='text-red-500'/>
                        </Button>
                    </div>

                    {currentItem.content}

                    <div className='flex flex-row gap-x-2 pt-2'>
                        {currentItemIndex > 0 && (
                            <Button variant='simple' size='xs' onClick={() => setCurrentItemIndex(currentItemIndex - 1)}>
                                <FontAwesomeIcon icon={faArrowLeft}/>
                            </Button>
                        )}

                        {currentItemIndex < items.length - 1 && (
                            <Button variant='simple' size='xs' className='ml-auto' onClick={() => setCurrentItemIndex(currentItemIndex + 1)}>
                                <FontAwesomeIcon icon={faArrowRight}/>
                            </Button>
                        )}

                        {currentItemIndex === items.length - 1 && (
                            <Button variant='simple' size='xs' className='ml-auto' onClick={() => setIsInternalWalkthroughOpen(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </Button>
                        )}
                    </div>
                </div>
            </Popover>
        </>
    )
}

export default Walkthrough;